module.exports = __webpack_public_path__ + "img/Review_text06_mainpoints.53621014.png";